//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import DefaultHeader from '../components/Headers/DefaultHeader' ;
import DefaultFooter from '../components/Footers/DefaultFooter' ;

export default ({
	components: {
		DefaultHeader,
		DefaultFooter,
	},
	data() {
		return {
		}
	},
	computed: {
		// Sets layout's element's class based on route's meta data.
		layoutClass() {
			return this.$route.meta.layoutClass ;
		}
	},
})

